// @ts-nocheck
import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const postBinanceWithdrawalService = async ({
  amount,
  to_address,
  network,
}: {
  amount: number | string;
  to_address: string;
  network: string;
}) => {
  const payload = {
    amount: amount.toString(),
    to_address,
    network,
  };
  const response = await privateRequest.post(`${ConfEnv.API_WALLET.URL_BINANCE_WITHDRAWAL}`, payload);
  return response;
};

//     amount: amount.toString(),
//   });
